import styled from 'styled-components';
import { Link } from "react-router-dom";
import colors from 'constants/colors';

export const Head = styled.div`
  position: relative;
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div {
    margin-top: 15px;
    margin-bottom: 10px;
    color: ${colors.white};
  }
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin: 10px 0;
  column-gap: 16px;

  .datePickerContainer {
    width: 50%;
    position: relative;

    span {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      column-gap: 8px;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 1px;
      color: ${colors.silver};
      margin-bottom: 5px;
      white-space: nowrap;
    }

    .datePlaceHolder {
      position: relative;
      top: 4px;
      left: 10px;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.5px;
      color: ${colors.silver};
      white-space: nowrap;
    }
  }
`;

export const Footer = styled.div`
  font-weight: 300;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
